import React from "react";
import "./styles/Painel.css";

export default function PainelHome({ funcao }) {
  return (
    <div className="PainelHome">
      <h2>O que deseja fazer?</h2>
      <div className="PainelHome-conteiner">
        <img
          src={require("../assets/images/switchDeviceIcon.png")}
          onClick={() => funcao(0)}
          alt="10"
        />
        <img
          src={require("../assets/images/veiculosIcon.png")}
          onClick={() => funcao(5)}
          alt="10"
        />
        <img
          src={require("../assets/images/implementosIcon.png")}
          onClick={() => funcao(6)}
          alt="10"
        />
        <img
          src={require("../assets/images/verTrabalhosIcon.png")}
          onClick={() => funcao(2)}
          alt="10"
        />
        <img
          src={require("../assets/images/shapeIcon.png")}
          onClick={() => funcao(4)}
          alt="10"
        />
      </div>
    </div>
  );
}
